define('SageDotCom/Components/Content/Buttons/SharePriceButton',[
    "jquery",
    "eventManager",
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/buttonClick',
    "underscore",
    "text!SageDotCom/Components/Templates/SharePriceTicker.html",
    "SageDotCom/Utility/sanitizer"
],
    function ($, eventManager, tealium, buttonClickEvent, _, sharePriceTemplate, sanitizer) {
        function SharePriceButton(scope, clickMessagesTransmitting,currency) {
            Object.defineProperties(this, {
                $scope: { enumerable: true, value: $(scope) }
            });
            //add click message transmitting to trigger modals for example
            if (clickMessagesTransmitting.length) {

                $(scope).attr('data-tracking', buttonClickEvent.getName());

                this.$scope.on("click", function (e) {
                    e.preventDefault();
                    clickMessagesTransmitting.forEach(function (ev) {
                        eventManager.trigger(ev, self);
                    });

                    var data = buttonClickEvent.GenerateEventMetadata(e.currentTarget);
                    tealium.event(data);

                    return !1;
                });
            }
            function CallController() {
                $.getJSON("/api/sagedotcom/SharePrice/GetSharePriceData", function (response) {

                    let currTemplate = sharePriceTemplate;

                    if (response != null) {
                        const data = response.Data;

                        if ((typeof (data) !== "undefined" && data !== null) 
                            && (typeof (data.Snapshot) !== "undefined" && data.Snapshot !== null)
                            && (typeof (data.Client) !== "undefined" && data.Client !== null)) {
                            let change = typeof(data.Snapshot.AbsChange) !== "undefined" && data.Snapshot.AbsChange !== null  ? data.Snapshot.AbsChange : 0;
                            let price = typeof(data.Snapshot.Price) !== "undefined" && data.Snapshot.Price !== null  ? data.Snapshot.Price : 0;
                            let arrowDirection = "nochange"
                            let changeString = change > 0 ? `+${change}` : change; // appends the minus by default for minus number
    
                            if (change > 0)  {
                                arrowDirection = "up"
                            } else if (change < 0) {
                                arrowDirection = "down"
                            }
    
                            currTemplate = currTemplate.replace('#CurrentSharePrice#', price);
                            currTemplate = currTemplate.replace('#OverrideCurrency#', currency);
                            currTemplate = currTemplate.replace('#SharePriceArrowClass#', arrowDirection);
                            currTemplate = currTemplate.replace('#SharePriceArrow#', arrowDirection);
                            currTemplate = currTemplate.replace('#SharePriceChange#', changeString);
                        }
                    } else if (response == null) {
                        currTemplate = currTemplate.replace('#CurrentSharePrice#', "-.--");
                        currTemplate = currTemplate.replace('#OverrideCurrency#', '');
                        currTemplate = currTemplate.replace('#SharePriceArrowClass#', '');
                        currTemplate = currTemplate.replace('#SharePriceArrow#', '');
                        currTemplate = currTemplate.replace('#SharePriceChange#', '');
                    }

                    let html = $("a.score-button.share-price-ticker").html();
                    html += currTemplate;

                    $("a.score-button.share-price-ticker").html(sanitizer.sanitizeHtml(html));
                });
            }

            CallController();
        }
       
        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new SharePriceButton(args.scope, args.clickMessages, args.currency);
        };
    });


